class MoonCalendarPreview extends HTMLElement {
  constructor() {
    super();

    // Retrieve data from the script tag directly
    this.metafieldsDataElement = this.querySelector('#metafields-data');

    // Parse the JSON data from the script element
    const metafieldsData = JSON.parse(this.metafieldsDataElement.textContent);

    // Store the metafields and preview data for later use
    this.previewData = metafieldsData.previewData;
    this.metafieldsData = metafieldsData;

    // Reference the preview image element
    this.previewImage = this.querySelector('#preview-image');

    window.theme = window.theme || {};
    window.theme.previewData = this.previewData;

    // Generate preview data based on metafields
    this.generatePreviewData();

    this.setPreviewImage();
    this.setItemsPosition();
    this.updateUnitSrc();

  }

  updateUnitSrc() {
    const unitImages = this.querySelectorAll('.unit-image');
    unitImages.forEach((unitImage) => {
      const unit = unitImage.dataset.unit;
      const index = unitImage.dataset.index;

      const currentSrc = unit === 'moon' ? 
      document.querySelector('.moon-phase-finder[data-index="'+index+'"] .selected-image img').src
      : document.querySelector('.birthstone-picker .selected-image img').src;

      unitImage.src = currentSrc;
    });
  }
  // Function to generate the preview data based on the metafields
  generatePreviewData() {
    const currentVariant = this.metafieldsData.currentVariant;
    const variantMetafieldInfo = this.metafieldsData.variantMetafieldInfo;
    const elementMetafieldInfo = this.metafieldsData.elementMetafieldInfo;
    const productMetafieldInfo = this.metafieldsData.productMetafieldInfo;
    const defaultInfo = this.metafieldsData.defaultInfo;

    if (variantMetafieldInfo[currentVariant.id].variant_preview_images) {
      if (variantMetafieldInfo[currentVariant.id].variant_preview_images.length === 4) {
        this.previewData.previewVersion = 'variantElement';
        const currentLabel = document.querySelector('.elements-picker .selected-image img').dataset.label;
        const currentElement = currentLabel ? currentLabel : 'fire';
        this.previewData.previewImageDt = this.getElementImages(currentElement, variantMetafieldInfo[currentVariant.id].variant_preview_images);
        this.previewData.previewImageMob = this.getElementImages(currentElement, variantMetafieldInfo[currentVariant.id].variant_preview_images_mobile);
      } else {
        this.previewData.previewVersion = 'variant';
        this.previewData.previewImageDt = variantMetafieldInfo[currentVariant.id].variant_preview_images;
        this.previewData.previewImageMob = variantMetafieldInfo[currentVariant.id].variant_preview_images_mobile;
      }
      this.previewData.previewCSS = variantMetafieldInfo[currentVariant.id].variant_preview_css;
      this.previewData.ratio = variantMetafieldInfo[currentVariant.id].aspect_ratio[0];
    } else if (elementMetafieldInfo.element_images_desktop && elementMetafieldInfo.element_images_desktop.length) {
      this.previewData.previewVersion = 'element';
      const currentLabel = document.querySelector('.elements-picker .selected-image img').dataset.label;
      const currentElement = currentLabel ? currentLabel : 'fire';
      this.previewData.previewImageDt = this.getElementImages(currentElement, elementMetafieldInfo.element_images_desktop);
      this.previewData.previewImageMob = this.getElementImages(currentElement, elementMetafieldInfo.element_images_mobile);
      this.previewData.previewCSS = elementMetafieldInfo.element_css;
      this.previewData.ratio = elementMetafieldInfo.aspect_ratio[0];
    } else if (productMetafieldInfo.preview_image_desktop && productMetafieldInfo.preview_image_desktop.length) {
      this.previewData.previewVersion = 'product';
      this.previewData.previewImageDt = productMetafieldInfo.preview_image_desktop;
      this.previewData.previewImageMob = productMetafieldInfo.preview_image_mobile;
      this.previewData.previewCSS = productMetafieldInfo.preview_css;
      this.previewData.ratio = productMetafieldInfo.aspect_ratio;
    } else {
      this.previewData.previewVersion = 'default';
      this.previewData.previewImageDt = defaultInfo.blank_image;
      this.previewData.previewImageMob = defaultInfo.blank_image;
      this.previewData.ratio = defaultInfo.default_aspect_ratio;
      this.previewData.previewCSS = defaultInfo.default_css;
    }
  }

  // Helper function to retrieve element images (could be further customized)
  getElementImages(code, images) {
    let elementCode;

    if ( code ) {
      code = code.toLowerCase();
      elementCode = code.split('-')[0];
    }
    
    let index = elementCode === 'water' ? 1 : elementCode === 'air' ? 2 : elementCode === 'earth' ? 3 : 0;
    return images[index];  
  }

  setItemsPosition() {
    const { previewCSS } = this.previewData;
    if (!previewCSS) return;

    for (const key in previewCSS) {
      if (previewCSS.hasOwnProperty(key)) {
        const element = previewCSS[key];
        const desktopElement = document.getElementById(`desktop-img-${key}`);
        const mobileElement = document.getElementById(`mobile-img-${key}`);
        if (desktopElement) {
          desktopElement.style.cssText = element.dt;
        }
        if (mobileElement) {
          mobileElement.style.cssText = element.mob;
        }
      }
    }
  }

  setPreviewImage() {
    if (!this.previewImage) return;

    const { previewImageDt, previewImageMob, ratio } = this.previewData;

    this.previewImage.querySelector('.preview-image--desktop').src = previewImageDt;
    this.previewImage.querySelector('.preview-image--mobile').src = previewImageMob;
  }
}

// Define the custom element for use in HTML
customElements.define('moon-calendar-preview', MoonCalendarPreview);